module.exports = __webpack_public_path__ + "static/media/text.3013a770.png";